import { useState, useEffect, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";
import {
    TopRatedStatus,
    TopRatedStatusTitle,
    MyNonprofitsTable,
} from "./dashboard";
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../../components/common/commonTable";
import { useNavigate } from "react-router-dom";
import { CategoryProps, NonprofitProps, TableColumnsProps } from "../../utils/types";
import { MESSAGE } from "../../utils/message";
import { userNonprofitHandler } from "../../redux/slices/myNonprofit/nonprofitList-slice";
import MetaComponent from "../../components/common/metaComponent";
import SimpleLoader from "../../components/common/simpleLoader/Loader";
import { flagActions } from "../../redux/slices/myNonprofit/flag-slice";

const Dashboard = () => {
    const nonprofitList: NonprofitProps[] = useSelector((state: any) => state?.userNonprofit?.data?.results ?? []);
    const data = useSelector((state: any) => state?.flag);

    const dispatch: any = useDispatch()
    const navigate = useNavigate()
    const [loader, setLoader] = useState(true);


    //   const [detailByRow, setDetailByRow] = useState<NonprofitProps>()

    // useEffect(() => {
    //     setLoader(true);
    //     dispatch(userNonprofitHandler())
    //         .then(() => setLoader(false))
    //         .catch(() => setLoader(false));
    // }, [])
    useEffect(() => {
        const fetchNonprofits = async () => {
            try {
                setLoader(true);
                await dispatch(userNonprofitHandler());
            } finally {
                setLoader(false);
            }
        };
        fetchNonprofits();
    }, [dispatch]);

    useEffect(() => {
        if (!loader && (!nonprofitList || nonprofitList.length === 0)) {
            dispatch(flagActions.setFlag(true));
            navigate("/organizations/find");
        }
    }, [loader, nonprofitList]);

    const handleRowClick = useCallback((row: NonprofitProps) => {
        if (row?.id) {
            // Only navigate after ensuring the API call has completed successfully
            navigate(`/dashboard/stats/${row.id}`, { replace: true });
        }
    }, [navigate]);
    // const handleRowClick = (row: NonprofitProps) => {
    //     if (row?.id) {
    //         navigate(`/dashboard/stats/${row.id}`, { state: { open: true } });
    //     }
    // };
    // useEffect(() => {
    //     if (detailByRow?.id) {
    //         navigate(`/dashboard/stats/${detailByRow.id}`, { state: { open: true } })
    //     }
    // }, [detailByRow])

    const columns: TableColumnsProps[] = [
        {
            id: 'title',
            header: 'Nonprofit Name'
        },
        {
            id: 'city',
            header: 'City and State'
        },
        {
            id: 'causes',
            header: 'Cause',
            render: (causes: CategoryProps[]) => {
                return <p>{causes?.map((item: CategoryProps) => item).join(', ')}</p>
            }
        }
    ]
    return (
        <>
            <MetaComponent
                keywords=""
                description=""
                ogTitle=""
                ogDescription=""
                ogUrl=""
                ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
            />
            <>
                <TopRatedStatus>
                    <Container className="cont-w">
                        <Row>
                            <Col sm="12">
                                <TopRatedStatusTitle>{MESSAGE.myNonprofits}</TopRatedStatusTitle>
                            </Col>
                        </Row>
                    </Container>
                </TopRatedStatus>
                {loader ? (
                    <div style={{ position: 'relative' }}>
                        <SimpleLoader />
                    </div>
                ) : (
                    <MyNonprofitsTable>
                        <Container className="cont-w">
                            <CommonTable columns={columns} data={nonprofitList?.length ? nonprofitList : []} handleRowClick={handleRowClick} />
                        </Container>
                    </MyNonprofitsTable>
                )}
            </>
        </>

    )
};
export default Dashboard; 